export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/sync-466023633db293b1877b5c8cee98fd95.svg";